import { SET_APP_ERROR_MESSAGE, RESET_APP_ERROR_MESSAGE } from "../types";

export const setErrorMessage = (errorMessage) => ({
  type: SET_APP_ERROR_MESSAGE,
  errorMessage,
});

export const setAppErrorMessage = (errorMessage) => (dispatch) => {
  dispatch(setErrorMessage({ errorMessage }));
};

export const resetErrorMessage = () => ({
  type: RESET_APP_ERROR_MESSAGE,
});

export const resetAppErrorMessage = () => (dispatch) => {
  dispatch(resetErrorMessage());
};



// WEBPACK FOOTER //
// ./src/actions/appMessage.js